import {Flex, List, Segmented} from "antd";
import React, {useEffect, useState} from "react";

export const ListResults = (
    props: {
        items: any[],
        height: number,
        languages: string[],
        onItemClick?: (string: any) => void,
    }
) => {
    const [language, setLanguage] = useState(props.languages[0]);

    useEffect(() => {
        setLanguage(props.languages[0])
    }, [props.items]);

    return (
        <Flex vertical={true} gap={16} style={{flexGrow: 1}}>
            <Segmented
                options={
                    props.languages.map((lang) => ({
                        value: lang,
                        label: lang
                    }))
                }
                value={language}
                onChange={(value) => {
                    setLanguage(value)
                }}/>
            <List
                style={{width: "100%", height: `calc(${props.height}px - 48px)`, overflowY: 'auto', scrollbarWidth: "none", cursor: 'pointer'}}
                dataSource={props.items}
                renderItem={(item: any, index) =>
                    <List.Item onClick={() => props.onItemClick?.(item)}>{index + 1}. {item[language]}</List.Item>}
            />
        </Flex>
    )
}